/* eslint-disable no-unused-vars no-undef */

const changeTitle = (to, from, next) => {
  const { name } = to;

  const TITLE = {
    login: 'Iniciar sesión',
    complaints: 'Todos los Reclamos',
    new: 'Nuevo Reclamo',
    new_pre_approved: 'Nuevo Reclamo Pre aprobado',
    operators: 'Empresas de buses',
    finance: 'Finanzas',
    all: 'Todos los Reclamos',
    confirm_email: 'Confirmar correo',
  };

  document.title = 'Recorrido';

  if (TITLE[name]) {
    document.title = `${TITLE[name]} | recorrido`;
  }

  next();
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const filterParams = (params, status) => {
  const mappings = {
    approved_reimbursement: ['reimbursement'],
    approved_communication: ['internal_messages'],
    rejected_communication: ['internal_messages'],
    pending_edb: ['response'],
    pending_info: ['internal_messages'],
    pending_requested: ['internal_messages'],
    rejected: ['response'],
    closed: ['response'],
    notified_rejection: ['response'],
    notified_approval: ['response'],
    pending_err: ['response'],
    reimbursement_error: ['response'],
  };

  if (status === 'pending_err' || status === 'refunded_ecommerce' || status === 'rejected_ecommerce') {
    return [];
  }
  const filtered = Object.keys(params)
    .filter(key => mappings[status].includes(key))
    .reduce((obj, key) => {
      obj[key] = params[key];
      return obj;
    }, {});
  return filtered;
};

export {
  changeTitle, filterParams,
};



// WEBPACK FOOTER //
// ./src/utils/functions.js